'use client';

import { QueryKeys } from '@/constants/query-keys';
import { PagedListOfTheater } from '@cinemark/content-api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useTheatersContext = (): ReturnType<typeof useQuery<PagedListOfTheater>> => {
  return useQuery({
    enabled: false,
    queryFn: (): Promise<PagedListOfTheater> => {
      // this should never actually run since we'll always have cached data
      // but we need a queryFn for TypeScript
      throw new Error('Theaters context issue has occurred');
    },
    queryKey: QueryKeys.global.theatersContext,
    retry: false,
    staleTime: Infinity,
  });
};

export const useUpdateTheatersContext = (): ReturnType<typeof useMutation<void, unknown, PagedListOfTheater | undefined>> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (theaters: PagedListOfTheater | undefined) => {
      if (theaters === undefined) {
        queryClient.removeQueries({ queryKey: QueryKeys.global.theatersContext });
      } else {
        queryClient.setQueryData(QueryKeys.global.theatersContext, theaters);
      }

      return Promise.resolve();
    },
  });
};
